import PageHeader from "../../Components/PageHeader/PageHeader";
import OrdersMainTable from "../../Components/OrdersMainTable/OrdersMainTable";

const OrderListing = () => {

    return (

        <div>

            {/* HEADER */}
            <PageHeader />
           

            {/* SEARCH BOX AND MAIN TABLE*/}
            <OrdersMainTable />

        </div>

    );

}

export default OrderListing;
